import { useRef } from 'react';
import { usePagination, CircularButton, Slider } from '@ui/kit';
import { wrapper, navigationButton, tokens, slider } from './_carousel.style.js';
import { Slide } from './atom.slide.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function CarouselSlider(props) {
  const sliderRef = useRef(null);
  const pagination = usePagination(props.slides, {
    sliderRef,
    infinite: true,
    type: "pages"
  });
  const desiredItemsPerPage = Math.min(props.options.carouselCount ?? 3, props.slides.length);
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [props.slides.length > pagination.itemsPerPage && /*#__PURE__*/jsx("div", {
      className: navigationButton,
      "data-direction": "backwards",
      children: /*#__PURE__*/jsx(CircularButton, {
        onClick: pagination.goBackwards,
        inversed: true,
        tabIndex: -1
      })
    }), /*#__PURE__*/jsx("div", {
      className: slider,
      style: tokens.itemsPerPage.__override(desiredItemsPerPage),
      "data-desired-count": desiredItemsPerPage,
      children: /*#__PURE__*/jsx(Slider, {
        wrapperRef: sliderRef,
        pagination: pagination,
        items: props.slides,
        infinite: true,
        children: (item, {
          isVisible,
          index
        }) => /*#__PURE__*/jsx(Slide, {
          isVisible: isVisible,
          model: item,
          desiredCarouselCount: desiredItemsPerPage,
          handleOpenSlideInLightbox: () => props.handleOpenInLightbox(index)
        })
      })
    }), props.slides.length > pagination.itemsPerPage && /*#__PURE__*/jsx("div", {
      className: navigationButton,
      "data-direction": "forwards",
      children: /*#__PURE__*/jsx(CircularButton, {
        onClick: pagination.goForwards,
        tabIndex: -1
      })
    })]
  });
}

export { CarouselSlider };
//# sourceMappingURL=_carousel.js.map
